<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="author">WILLIAM<br/>
HEFFERNAN</p>
<p class="author">RED ANGEL</p>
<p class="subtitle">A PAUL DEVLIN MYSTERY</p>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062028976_epub_tp_r1.vue?739ac138